export default "__VITE_ASSET__Bd4LBI5X__"